// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --width: 100%;
  --height: 100%;
  --padding: 0 10px;
  height: var(--height);
  width: var(--width);
  padding: var(--padding);
  display: flex;
  justify-content: center;
  gap: 19px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/tab-bar/tab-bar.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,cAAA;EACA,iBAAA;EAGA,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AADJ","sourcesContent":[":host {\r\n    --width: 100%;\r\n    --height: 100%;\r\n    --padding: 0 10px;\r\n\r\n\r\n    height: var(--height);\r\n    width: var(--width);\r\n    padding: var(--padding);\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 19px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
